import { ArrowLeft } from "lucide-react";

import { Button } from "@/shared/components/ui/button";

interface JobApplicantsHeaderProps {
  onBack: () => void;
}

export default function JobApplicantsHeader({
  onBack,
}: JobApplicantsHeaderProps) {
  return (
    <Button variant="outline" onClick={onBack}>
      <ArrowLeft size={16} className="mr-2" />
      Back
    </Button>
  );
}
